import { blotterPreferenceStatePersistenceApiConnector } from 'apiConnector/blotters/blotterPreferenceStatePersistance';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import { catchError, debounceTime, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import {
  scheduledQuotesBlotterPreferenceStateLoaded,
  scheduledQuotesBlotterPreferenceStateLoadingFailed,
} from 'state/blotters/scheduledQuotes';
import type { EpicWithThunk } from 'state/state.common';

import { toBlotterPreferences } from '../../shared/preferenceState/preferenceStateEpics.helper';

export function persistPreferenceStateEpic(
  aggregationFrequency: number = 1000,
  scheduler?: SchedulerLike,
): EpicWithThunk {
  return (
    actions$,
    state$,
    {
      httpClient,
      selectors: {
        scheduledQuotesBlotter: { canSaveBlotterPreferences },
      },
    },
  ) =>
    actions$.pipe(
      ofType('SCHEDULED_QUOTES_BLOTTER_PREFERENCE_STATE_PERSISTED'),
      withLatestFrom(state$),
      filter(([, state]) => canSaveBlotterPreferences(state)),
      debounceTime(aggregationFrequency, scheduler),
      mergeMap(([action]) => {
        return blotterPreferenceStatePersistenceApiConnector(httpClient)
          .saveState(action.blotterPreferenceState, 'scheduledQuotes')
          .pipe(
            mergeMap(_ => EMPTY),
            catchError(_ => EMPTY),
          );
      }),
    );
}

export function loadPreferenceStateEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { getState } = blotterPreferenceStatePersistenceApiConnector(httpClient);
    return actions$.pipe(
      ofType('SCHEDULED_QUOTES_BLOTTER_PREFERENCE_STATE_GET'),
      mergeMap(() => {
        return getState('scheduledQuotes').pipe(
          map(response => scheduledQuotesBlotterPreferenceStateLoaded(toBlotterPreferences(response))),
          catchError(_ => of(scheduledQuotesBlotterPreferenceStateLoadingFailed())),
        );
      }),
    );
  };
}
